import CONST_STYLE from '../../constants/styles'

const styles = {
  caption : {
    color : CONST_STYLE.colors.CAPTION,
    fontSize : '12px',
    LetterSpacing : '0.4px'
  },
  bold : {
    fontWeight : '700',
    fontSize : '24px',
  },
  change : {
    color : CONST_STYLE.colors.PRIMARY_700,
    fontSize : '12px',
  }
}

export default styles;